import request from '@/CommonDP/utils/request';

export default {
  // 获取族库类型树
  getFamilyLibrary(enterpriseId) {
    return request
      .get(`/family/new/getFamilyTypeTree?enterpriseId=${enterpriseId}`)
      .then((res) => res);
  },
  // 族类型列表
  getLibraryList(params) {
    return request.post(`/family/new/getFamilyRecords`, params).then((res) => res);
  },
  // 添加族类型
  addFamilyLibrary(params) {
    return request.post(`/family/new/addFamilyType`, params).then((res) => res);
  },
  // 修改族类型
  editFamilyLibrary(params) {
    return request.post(`/family/new/updateFamilyType`, params).then((res) => res);
  },
  // 删除族类型
  deleteFamilyType(familyTypeId) {
    return request
      .get(`/family/new/deleteFamilyType?familyTypeId=${familyTypeId}`)
      .then((res) => res);
  },
  // 获取历史版本数据
  getFamilyVersion(params) {
    return request.post(`/family/new/getFamilyVersion`, params).then((res) => res);
  },
  // 上传族/批量上传族
  getFamilyNewUploadFamilys(params) {
    return request.post(`/family/new/uploadFamilys`, params).then((res) => res);
  },
  // 删除族文件
  deleteFamilyRecords(params) {
    return request.post(`/family/new/deleteFamilyRecords`, params).then((res) => res);
  },
  //
  getFamilyDocByEnterpriseId(enterpriseId) {
    return request
      .get(`/family/new/getFamilyDocByEnterpriseId?enterpriseId=${enterpriseId}`)
      .then((res) => res);
  },
  // 重新轻量化
  covrtExe(id) {
    return request
      .get(`/family/new/again/covrtExe/${id}`)
      .then((res) => res);
  },
  // 修改族文件(缩略图/名称)
  updateFamilyRecord(params) {
    return request.post(`/family/new/updateFamilyRecord`, params).then((res) => res);
  },
  // 批量增加族文件属性
  bathSupplementProperties(params) {
    return request.post(`/family/new/bathSupplementProperties`, params).then((res) => res);
  }

};
